import { generateAsyncSagaWatcher } from '../../../utils';

import { ELoginActions } from './enums';
import { ILoginFormResponse } from './models';

export const loginSaga = generateAsyncSagaWatcher<ILoginFormResponse>(ELoginActions.LOGIN);
